import React, { useEffect, useState } from "react";
import "../../Styles/Profle/ProfileHome.css";
import { useNavigate } from "react-router-dom";
import api from "../../api";
import { showToast } from "../../Components/PopupMessage";

function ProfileHome() {
  const [profile, setProfile] = useState({});
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");

  const access_token = localStorage.getItem("accessToken");

  useEffect(() => {
    if (!access_token) {
      navigate("/login");
    } else {
      try {
        JSON.parse(access_token);
      } catch (error) {
        console.error("Invalid access token format:", error);
        localStorage.removeItem("accessToken");
        navigate("/login");
      }
    }
  }, [access_token, navigate]);

  useEffect(() => {
    getProfile();
  }, []);

  const getProfile = async () => {
    try {
      // const token = JSON.parse(rawToken);
      const response = await api.get(`/user_api/get-user-details?access_token=${JSON.parse(access_token)}`);
      if (response.data.status === "success") {
        const user = response.data.user_details[0];
        console.log(user);
        setProfile(user);
        setFirstName(user.first_name || "");
        setLastName(user.last_name || "");
        setPhone(user.number || "");
        // showToast("Profile data fetched successfully!", "success");
      } else {
        console.log("Failed to fetch profile data");
        showToast("Failed to fetch profile data. Try again.", "error");
      }
    } catch (error) {
      alert("Something went wrong while fetching profile data");
      console.error("Error fetching profile:", error);
    }
  };

  const updateProfile = async (event) => {
    event.preventDefault();
    try {
      // const token = JSON.parse(rawToken);
      const response = await api.post(`/user_api/update-user-profile`, {
        access_token: JSON.parse(access_token),
        first_name: firstName,
        last_name: lastName,
        mobile_no: phone,
      });

      if (response.data.status === "success") {
        getProfile();
        showToast("Profile updated successfully!", "success");
      } else {
        showToast("Failed to update profile. Try again.", "error");
        console.log("Something went wrong");
      }
    } catch (error) {
      console.error("Error saving Profile", error);
      showToast("Error saving profile. Please try again.", "error");
    }
  };

  return (
    <div className="ProfileHome_div"
    style={{width:"100%"}}
    >
      <div className="Profile_text">Profile</div>
      <div className="View_update_text_div">
        View & Update Your Personal and Contact Information
      </div>

      <form className="ProfileHome_form" onSubmit={updateProfile}>
        <div className="ProfileHome_form_div">
          <div className="ProfileHome_form_name">Contact Information</div>
          <div className="Contact_information"
          style={{display: "flex", gap: "4px",alignItems: "center",justifyContent: "space-between"}}
          >
            <div className="Contact_information_div1">
              <label>Email</label>
              <input
                type="email"
                placeholder="Enter Email"
                className="Contact_information_input"
                value={profile.email || ""}
                disabled
                style={{width:"120%"}}
              />
            </div>
            <div className="Contact_information_div2">
              <label>Phone Number</label>
              <input
                type="number"
                placeholder="Enter Phone number"
                className="Contact_information_input"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                style={{width:"120%"}}
              />
            </div>
          </div>
        </div>

        <div className="Personal_Information_div">
          <div className="Personal_Information_div_TEXT">
            Personal Information
          </div>
          <div className="personal_information_input_divs"
          style={{display: "flex", gap: "8px",alignItems: "center",justifyContent: "space-between"}}
          >
            <div className="Personal_Information_div1">
              <label>First Name</label>
              <input
                type="text"
                placeholder="Enter First Name"
                className="Personal_Information_input"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                style={{width:"120%",}}
              />
            </div>
            <div className="Personal_Information_div2">
              <label>Last Name</label>
              <input
                type="text"
                placeholder="Enter Last Name"
                className="Personal_Information_input"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                 style={{width:"120%",}}
              />
            </div>
          </div>
        </div>

        <div>
          <button className="update_profile_button" type="submit">
            Update Profile
          </button>
        </div>
      </form>
    </div>
  );
}

export default ProfileHome;
